import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const accountEdit = http.put(
  createMockEndpoint('/account/:id'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
